export default __webpack_public_path__ + "static/media/signingContract.f5f3a799.svg";